import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Button, Checkbox, Header, Menu } from "semantic-ui-react";
import { openModal } from "../../../app/common/modals/modalReducer";
import CardColumn from "../../card/CardColumn";

import SubNavBar from "../../nav/SubNavBar";
import SectionDashboard from "../../section/SectionDashboard";
import SectionList from "../../section/SectionList";
import VisualList from "./VisualList";

export default function VisualDashboard() {
  const { spaceId, workspaceId } = useParams();
  const dispatch = useDispatch();
  const [cancelView, setCancelView] = useState(false);
  return (
    <>
      <SubNavBar>
        <Menu.Item>
          <Button
            icon='plus'
            inverted
            color='orange'
            onClick={() => {
              dispatch(
                openModal({
                  modalType: `SectionFormModal`,
                  modalProps: {
                    workspaceId,
                    spaceId,
                    selectedDoc: null,
                    collection: "visuals",
                  },
                })
              );
            }}
          />
        </Menu.Item>
        <Menu.Item>
          <Header
            style={{ color: "#28292B" }}
            id='fonts'
            inverted
            content={"Visuals"}
          />
        </Menu.Item>
        <Menu.Item>
          <Checkbox
            toggle
            onChange={() => {
              setCancelView(!cancelView);
            }}
          />
        </Menu.Item>
      </SubNavBar>
      <SectionDashboard cancelView={cancelView} sectionId='visuals'>
        <SectionList>
          <CardColumn collection={"visuals"}>
            <VisualList />
          </CardColumn>
        </SectionList>
      </SectionDashboard>
    </>
  );
}
